import { useMemo } from "react";

export default function Fireflies({ count = 18 }) {
  const flies = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        top: Math.random() * 90 + 2,
        left: Math.random() * 96 + 1,
        delay: (Math.random() * 8).toFixed(2),
        duration: (6 + Math.random() * 8).toFixed(2),
        scale: (0.5 + Math.random() * 1.2).toFixed(2),
      })),
    [count]
  );

  return (
    <div className="pointer-events-none fixed inset-0 -z-[5] overflow-hidden">
      {flies.map((f) => (
        <span
          key={f.id}
          className="firefly"
          style={{
            top: `${f.top}%`,
            left: `${f.left}%`,
            animationDelay: `${f.delay}s`,
            animationDuration: `${f.duration}s`,
            transform: `scale(${f.scale})`,
          }}
        />
      ))}
    </div>
  );
}
